export default "__VITE_ASSET__70489567__"